var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4"},[_c('h1',{staticClass:"has-text-weight-semibold is-size-5 mb-2"},[_vm._v(_vm._s(_vm.title))]),_c('pre',{staticClass:"display-height"},[_vm._v(_vm._s(_vm.list))])])
}
var staticRenderFns = []

export { render, staticRenderFns }